<div class="bg-th-yellow mt-0 container-fluid py-2">

    <div class="d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-secondary my-auto pointer text-dark" [routerLink]="['/']"></i>

        <a class="d-flex align-items-center text-secondary f18 my-auto text-dark">

            <span class="fw-bold"> کاربران آنلاین </span>

        </a>

    </div>

</div>

<main class="px-2">

    <!-- جدول اطلاعات -->

    <div class="border border-2 container-fluid row gx-0 gy-2 mt-3 p-2">

        <!-- جستجو -->

        <div class="col-7">

            <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." (input)="filter_Result($event.target.value)">

        </div>

        <!-- پیام به کاربران منتخب -->

        <div class="col-auto px-2">

            <button class="h-100 btn btn-outline-primary">

                پیام به کاربران منتخب

            </button>

        </div>

        <!-- خروج اجباری کاربران منتخب -->

        <div class="col-auto px-2">

            <button class="h-100 btn btn-outline-danger" (click)="exitAllCars()">

                خروج اجباری کاربران منتخب

            </button>
            
        </div>

        <!-- جدول اطلاعات -->

        <div class="section border border-2 mt-2">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="text-center">

                        <th scope="col" class="">#</th>

                        <th scope="col" class="pointer" (click)="selectAllCheckBox()"> انتخاب </th>

                        <th scope="col" class=""> نام </th>
                        
                        <th scope="col" class=""> حوزه خدمت </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="f14 text-center" *ngFor="let item of onlineUsersArray;let i=index">

                        <th class="text-dark"> {{ i + 1 | faNum }}</th>

                        <th class="">

                            <input type="checkbox" (change)="setCheckBox($event.target.checked,item)" [checked]="isSelected(item.iSystemUser)">

                        </th>

                        <td> {{ item.strFullName | faNum }} </td>

                        <td> {{ item.strMobileDomain_strComment | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>